import io from 'socket.io-client';

export default io(undefined, { transports: ['websocket'] });



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/socket.js